<i
    style="outline: 0"
    type="button"
    role="button"
    [id]="id"
    [class]="iconClass"
    [class.tooltip-disabled]="tooltipDisabled"
    [tabindex]="tabindex"
    [pTooltip]="tooltipText ? (tooltipText | translate) : tooltipContent"
    [tooltipStyleClass]="styleClass"
    [tooltipPosition]="position"
    [tooltipDisabled]="tooltipDisabled"
    [ariaLabel]="tooltipText ? (tooltipText | translate) : ('info.tooltip.defaultMessage' | translate)"
    [tooltipEvent]="''"
    [escape]="tooltipEscape"
    (focus)="activateTooltip($event)"
    (focusout)="deactivateTooltip($event)"
    (click)="activateTooltip($event)"
    (mouseover)="activateTooltip($event)"
    (mouseout)="deactivateTooltip($event)"></i>

<ng-template #tooltipContent>
    <div class="tooltip-custom-content">
        <ng-content [select]="'tooltip-content'"></ng-content>
    </div>
</ng-template>
